<div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
<ng-container *ngIf="!isLoading">
  <pagination-controls
    *ngIf="subscriptions?.length > 10"
    (pageChange)="changePage($event)"
    previousLabel="Previous"
    directionLinks="false"
    nextLabel="Next"
    screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="page"
    screenReaderCurrentLabel="You're on page"
  >
    ></pagination-controls
  >
  <ul class="booking-list" *ngIf="subscriptions && subscriptions?.length > 0">
    <li
      class="booking-list__card"
      *ngFor="
        let subscription of subscriptions
          | paginate: { itemsPerPage: 10, currentPage: p };
        index as itemIndex
      "
    >
      <app-attendee-booking-detail
        [subscription]="subscription"
        [canRefund]="canRefund(subscription)"
        [type]="listType"
        (cancelled)="subscriptionCancelled(subscription)"
        [isPastTab]="isPastActivityTab"
        [isOpened]="itemIndex === 0 ? true : false"
        [bookingId]="subscription?.item?.bookingId"
      ></app-attendee-booking-detail>
    </li>
  </ul>
  <pagination-controls
    *ngIf="subscriptions?.length > 10"
    (pageChange)="p = $event"
    previousLabel="Previous"
    directionLinks="false"
    nextLabel="Next"
    screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="page"
    screenReaderCurrentLabel="You're on page"
  >
    ></pagination-controls
  >

  <ng-container *ngIf="subscriptions && subscriptions?.length === 0">
    <app-tips
      class="block mt-4"
      [icon]="icons.Information"
      [variant]="tipsVariant.WARNING"
      [title]="'bookings.no_results.title' | translate"
      [tips]="'bookings.no_results.description' | translate"
    >
    </app-tips>

    <a
      app-vtmn-play-button
      [routerLink]="'/' | localize"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      class="mt-4"
    >
      {{ 'bookings.no_results.explore' | translate }}
    </a>

    <div class="spinner mx-auto mt-4" *ngIf="!subscriptions"></div>
  </ng-container>
</ng-container>
<ng-container *ngIf="hasSubscriptionError">
  <app-tips
    class="block mt-4"
    [icon]="icons.Information"
    [variant]="tipsVariant.WARNING"
    [title]="'bookings.error.title' | translate"
    [tips]="'bookings.error.description' | translate"
  >
  </app-tips>
</ng-container>
